import { Zap } from "lucide-react";
import { MARQUEE_ITEMS } from "../data/siteData";

export const Marquee = () => (
    <div
        data-testid="trust-marquee"
        className="relative overflow-hidden border-y border-white/10 bg-[#0d1220]"
        aria-hidden="true"
    >
        <div className="animate-marquee flex w-max items-center py-4">
            {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map((item, i) => (
                <span key={`${item}-${i}`} className="flex items-center whitespace-nowrap">
                    <span className="font-display px-8 text-sm font-bold tracking-[0.3em] text-slate-300">
                        {item}
                    </span>
                    <Zap className="h-4 w-4 shrink-0 text-[#E61C24]" />
                </span>
            ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0d1220] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0d1220] to-transparent" />
    </div>
);
